import { useState, useEffect } from 'react';

const JTO_MINT = 'jtojtomepa8beP8AuQc6eXt5FriJwfFMwQx2v2f9mCL';

export const useJtoPrice = () => {
    const [price, setPrice] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchPrice = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await fetch(
                `https://lite-api.jup.ag/price/v3?ids=${JTO_MINT}`
            );
            const data = await response.json();
            const jupPrice = data?.[JTO_MINT]?.usdPrice;
            if (typeof jupPrice === 'number') {
                setPrice(jupPrice);
            } else {
                throw new Error('Jupiter price data not found');
            }
        } catch (err) {
            console.error('Error fetching JTO price from Jupiter:', err);
            setError('Error fetching JTO Price');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPrice();
    }, []);

    return { price, isLoading, error };
};
